<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Дата выдачи</div>
            <div class="dx-field-value">
                <dx-date-box :value="data.egrul_cert_date" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { DxDateBox } from 'devextreme-vue';

const data = inject('serverData');
</script>
